import { RouteObject } from "react-router";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";

import { routes } from "@pages/routes";

import { Integrations } from "./Integrations/Integrations.page";
import { MicrosoftPartnerCenterCallback } from "./MicrosoftPartnerCenterCallback/MicrosoftPartnerCenterCallback.page";

export const integrationsRoutes = [
  {
    path: routes.portal.integrations.$path(),
    Component: PortalPage,
    children: [
      {
        index: true,
        Component: Integrations,
        handle: {
          breadcrumb: {
            title: "Integrations",
          },
        },
      },
      {
        path: routes.portal.integrations.microsoftPartnerCenter.$path(),
        Component: MicrosoftPartnerCenterCallback,
        handle: {
          breadcrumb: {
            title: "Microsoft Partner Center",
          },
        },
      },
    ],
  },
] satisfies RouteObject[];
